import {Injectable} from "@angular/core";
import {SmartLibraryApplication, SmartLibraryApplicationLabel} from "./dtos/enums/smart-library-application.enum";
import * as semver from "semver";

@Injectable()
export class UtilitiesService {
    getApplicationName(applicationId: number) : string {
        return SmartLibraryApplicationLabel.get(applicationId);
    }

    getApplicationNames(applicationIds: number[]) : string[] {
        return applicationIds.map(x => this.getApplicationName(x));
    }

    getApplicationIcon(applicationId: number) : string {
        return `assets/images/application-icons/${SmartLibraryApplication[applicationId]}.png`;
    }

    loadDefaultApplicationIcon(event: ErrorEvent) {
        (<HTMLImageElement>event.target).src = "assets/images/application-icons/GenericInformation.png";
    }

    areVersionsEqual(v1: string, v2: string) : boolean {
        let parsed1 = semver.valid(semver.coerce(v1))
        let parsed2 = semver.valid(semver.coerce(v2))

        if (parsed1 == null || parsed2 == null) return false;

        return semver.eq(parsed1, parsed2);
    }

    isEmptyOrSpaces(string: string) : boolean {
        return string === null || string.match(/^\s*$/) !== null;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/utilities.service.ts